import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  ItemCostAllocation,
  type ItemCostAllocationConstructor,
} from './ItemCostAllocation'

export const ItemCostAllocationConstructorFactory =
  Factory.Sync.makeFactory<ItemCostAllocationConstructor>({
    budgetId: Factory.each(() => faker.random.number()),
    amount: Factory.each(() => faker.finance.amount()),
    accountCode: Factory.each(() => ({
      id: faker.random.number(),
      code: '6000',
      description: faker.commerce.department(),
    })),
    primaryCategory: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.address.city(),
    })),
    secondaryCategory: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.commerce.department(),
    })),
  })

export const ItemCostAllocationFactory = EntityFactory(
  ItemCostAllocation,
  ItemCostAllocationConstructorFactory
)
